module.exports = __webpack_public_path__ + "media/images/webinar-1-39b4af01c191901ce9e16718b0307dde.jpg";